import Web3 from "web3";
import { store } from "../Redux/store";
import { IDOSaleABI_ } from "../config/abi/IDOSaleContract";
import { PayoutTokenABI } from "../config/abi/PayoutTokenContract";
import { InfinityFactoryContractABI } from "../config/abi/InfinityFactoryContract";
import {
  PayoutContractAddress,
  StackPayoutContractAddress,
} from "../config/constants/Contracts";
import { InfinityFactoryContractAddress } from "../config/constants/Contracts";

import { InfinityStackingABI } from "../config/abi/InfinityStacking";

import { InfinityStackingAddress } from "../config/constants/Contracts";

import Swal from "sweetalert2";
import { StackPayoutContract } from "../config/abi/StackPayoutContract";

export const web3_ = new Web3(window.ethereum);
const _InfinityFactoryContract = new web3_.eth.Contract(
  InfinityFactoryContractABI,
  InfinityFactoryContractAddress
);

//++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

// Infinity Stacking Contract Address and ABI Definitions
export const _InfinityStackingsContract = async () => {
  const Contract_ = new web3_.eth.Contract(
    InfinityStackingABI,
    InfinityStackingAddress
  );
  return Contract_;
};

// Infinity Stacking function: ----------------------------------------------------------------

export const _INFP_Stack_btn = async (contract, value) => {
  let address = store.getState().ConnectivityReducer.metamaskAddress;
  const Contract_ = new web3_.eth.Contract(
    InfinityStackingABI,
    InfinityStackingAddress
  );

  return await Contract_.methods
    .PoolStake(web3_.utils.toWei(value.toString(), "ether"))
    .send({ from: address })
    .on("transactionHash", function (transactionHash) {})
    .on("confirmation", () => {})
    // get New Contract Address

    .then(() => Swal.fire("Transaction Successful", "", "success"))
    .catch((err) => Swal.fire(err.message, "", "warning"));
};

export const _INFP_Unstack_btn = async (contract, address) => {
  const Contract_ = new web3_.eth.Contract(InfinityStackingABI, contract);
  return await Contract_.methods
    .claimPool(true)
    .call({ from: address })
    .on("transactionHash", function (transactionHash) {})
    .on("confirmation", () => {})
    // get New Contract Address

    .then(() => Swal.fire("Transaction Successful", "", "success"))
    .catch((err) => Swal.fire(err.message, "", "warning"));
};

export const _INFP_Reward = async (contract, address) => {
  const Contract_ = new web3_.eth.Contract(InfinityStackingABI, contract);
  return await Contract_.methods
    .rewardsCalculate()
    .call({ from: address })
    .on("transactionHash", function (transactionHash) {})
    .on("confirmation", () => {})
    // get New Contract Address

    .then(() => Swal.fire("Transaction Successful", "", "success"))
    .catch((err) => Swal.fire(err.message, "", "warning"));
};

//++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

/*----------------------------------------------------------------------------------------------------------------------------- */

// Infinity factory Contract:

export const _InfinityFactoryContractGetAllDataByAddress = async () => {
  let data = await _InfinityFactoryContract.methods
    .getAllIntractionDetails()
    .call();
  return data;
};
export const _InfinityFactoryContractGetDataByAddress = async (address) => {
  let data = await _InfinityFactoryContract.methods
    .getDataByAddress(address)
    .call();
  return data;
};
export const _IDOSaleContractData = async (address) => {
  const Contract = new web3_.eth.Contract(IDOSaleABI_, address);
  let data = Contract._jsonInterface;
  return { data: data, Contract: Contract };
};

export const _IDOSaleGetWhiteListed = async (address) => {
  const Contract = new web3_.eth.Contract(IDOSaleABI_, address);
  return await Contract.methods.GetAllWhiteListed().call();
};

export const _IDOSaleTotalCollectedFunds = async (address) => {
  const Contract = new web3_.eth.Contract(IDOSaleABI_, address);

  return await Contract.methods.TotalCollectedBNBFund().call();
};
export const _IDOSaleUserClaim = async (address) => {
  const Contract = new web3_.eth.Contract(IDOSaleABI_, address);
  return await Contract.methods
    .UserClaim(store.getState().ConnectivityReducer.metamaskAddress)
    .send({ from: store.getState().ConnectivityReducer.metamaskAddress });
};

export const _IDOLaunchPadParticipate = async (contract, address, value) => {
  const Contract = new web3_.eth.Contract(IDOSaleABI_, contract);
  // return await Contract.methods
  //   .SaleIDOToken(address, 12313)
  //   .send({ from: address });
};

export const _PayoutContract = async () => {
  const Contract = new web3_.eth.Contract(
    PayoutTokenABI,
    PayoutContractAddress
  );
  return Contract;
};
export const _StackPayoutContract = async () => {
  const Contract = new web3_.eth.Contract(
    StackPayoutContract,
    StackPayoutContractAddress
  );
  return Contract;
};
export const _getSellTrack = async (address) => {
  const Contract = new web3_.eth.Contract(IDOSaleABI_, address);
  return await Contract.methods
    .getSellTrack(store.getState().ConnectivityReducer.metamaskAddress)
    .call();
};

export const _getUserClaim = async (address) => {
  const Contract = new web3_.eth.Contract(IDOSaleABI_, address);
  return await Contract.methods
    .getUserClaim(store.getState().ConnectivityReducer.metamaskAddress)
    .call();
};

export const _sellForAll = async (address) => {
  const Contract = new web3_.eth.Contract(IDOSaleABI_, address);
  return await Contract.methods.sellForAll().call();
};

export const _GetMaxBuy = async (address) => {
  const Contract = new web3_.eth.Contract(IDOSaleABI_, address);
  return await Contract.methods
    .GetMaxBuy(store.getState().ConnectivityReducer.metamaskAddress)
    .call();
};

export const _getCheckWhiteListed = async (address) => {
  const Contract = new web3_.eth.Contract(IDOSaleABI_, address);
  return await Contract.methods
    .getCheckWhiteListed(store.getState().ConnectivityReducer.metamaskAddress)
    .call();
};

export const _is_sellStatus = async (address) => {
  const Contract = new web3_.eth.Contract(IDOSaleABI_, address);
  return await Contract.methods.is_sellStatus().call();
};

export const _ClaimCounter = async (address) => {
  const Contract = new web3_.eth.Contract(IDOSaleABI_, address);
  return await Contract.methods.ClaimCounter().call();
};
